// extracted by mini-css-extract-plugin
export default {"UsersInfoPanel":"UserEditPanel_UsersInfoPanel__2y-A0","buttonsPanel":"UserEditPanel_buttonsPanel__rDn00"};